// extracted by mini-css-extract-plugin
module.exports = {"choice":"QuestionChoice_choice__2lg3P","image":"QuestionChoice_image__103dn"};